import { useEffect, useState } from 'react';

import { OrganizationItem } from 'models/organization';
import { api } from 'services/api';

export function useOrganizations(): OrganizationItem[] {
  const [organizationItems, setOrganizationItems] = useState<
    OrganizationItem[]
  >([]);

  useEffect(() => {
    (async () => {
      try {
        const [organizations, mapped] = await Promise.all([
          api.get<{ data: { id: number; name: string }[] }>(
            '/admin/organizations',
            { params: { sortBy: JSON.stringify({ name: 'asc' }) } }
          ),
          api.get<{ data: number[] }>(
            '/admin/filter-options/mapped-organizations'
          )
        ]);
        const mappedIds = new Set(mapped.data);

        setOrganizationItems(
          organizations.data.map(({ id, name }) => ({
            id,
            name,
            isMapping: mappedIds.has(id)
          }))
        );
      } catch (error) {
        Promise.reject((error as Error).message);
      }
    })();
  }, []);

  return organizationItems;
}
